import { STATIC_BASE_URL } from '../config';

/**
 * Resolves a media URL (image, audio, subtitle) to a full URL.
 * - Returns '' for falsy inputs
 * - Passes through blob:, http://, and https:// URLs unchanged
 * - Prepends STATIC_BASE_URL for relative paths
 */
export const resolveMediaUrl = (url?: string | null): string => {
  if (!url) return '';
  if (url.startsWith('blob:') || url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${STATIC_BASE_URL}/${url.replace(/^\//, '')}`;
};

/**
 * Get the small card thumbnail URL from a thumbnail URL.
 * Convention: xxx.webp → xxx_sm.webp
 * Falls back to the original URL for non-webp thumbnails (legacy PNGs).
 */
export const getSmallThumbnailUrl = (url?: string | null): string => {
  if (!url) return '';
  if (url.endsWith('.webp')) {
    return resolveMediaUrl(url.replace(/\.webp$/, '_sm.webp'));
  }
  return resolveMediaUrl(url);
};
